/* eslint-disable no-mixed-operators */
/* eslint-disable array-callback-return */
import React, { Component } from "react";
import { imsLoader } from "../../assets";
import { withRouter } from 'react-router-dom';
import axios from "axios";
import { GenAIAnsweringContext } from '../GenAIAnswering2.0/GenAIAnsweringContextProvider';
import { Authentication } from "../../utils/authenticationUtilityServices";

class NoteBookPreview extends Component {
    static contextType = GenAIAnsweringContext
    constructor(props) {
        super(props);
        this.state = {
            previewURL: '',
            apiURL: '',
            selectedSource: null,
            selectedPageNumber: [],
            isProcessing: true,
            PageNumber: 1,
            isMultiFiles: null,
            attachedFiles: [],
            DisplayString: [],
            isChangePage: false,
            fileType:''
        }

    }
    componentDidMount = async () => {
        const queryParams = new URLSearchParams(this.props.location.search);
        let sessionID = this.props.match.params.id;
        let _id = queryParams.get("docid");
        let prviewObject = window[`${sessionID}-${_id}`];
        console.log(prviewObject)
        if (prviewObject) {
            this.setState({
                selectedSource: prviewObject.selectedSource,
                selectedPageNumber: prviewObject.selectedPageNumber,
                attachedFiles: prviewObject.attachedFiles,
            })
            let { selectedSource, } = prviewObject;
            let singleFile = selectedSource[0];
            var url = URL.createObjectURL(singleFile);

            let isImageUpload = singleFile.name.toLowerCase().endsWith('.gif')
                || singleFile.name.toLowerCase().endsWith('.jpeg')
                || singleFile.name.toLowerCase().endsWith('.jpg')
                || singleFile.name.toLowerCase().endsWith('.png')
            this.setState({ previewURL: url,fileType: isImageUpload ? 'image' : 'application/pdf'}, async () => {
                this.setState({ isProcessing: false })
            })

            // if (decodeURIComponent(selectedSource.download_url).includes("csID=29") || decodeURIComponent(selectedSource.download_url).includes("csID=31")) {
            //     var href = new URL(`https://ims.jnj.com${selectedSource.download_url}`);
            //     href.searchParams.set('connID', '7');
            //     href.searchParams.set('csID', '50');
            //     href.searchParams.set('fileType', 'pdf');
            //     apiURL = href.toString();
            // } else {
            //     apiURL = `https://ims.jnj.com${selectedSource.download_url}`
            // }
            // if (selectedSource.enclosureDocID && selectedSource.enclosureDocID.toString().trim()) {
            //     apiURL += `&enclosureID=${selectedSource.enclosureDocID}`
            // }
            // this.setState({ apiURL: apiURL }, async () => {
            //     await this.fetchDocument();
            // })
        }
        else {
            this.setState({ previewURL: "" }, async () => {
                this.setState({ isProcessing: false })
            })
        }

    }

    fetchDocument = async () => {
        const { apiURL } = this.state;
        const _headers = {}
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(
            apiURL,
            {
                headers: _headers,
                responseType: "blob",
            }
        ).then((response) => {
            const data = new Blob([response.data], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(data)
            this.setState({ previewURL: url }, async () => {
                this.setState({ isProcessing: false })
            })
        }).catch((error) => {
            console.log(error);
            this.setState({ previewURL: "" }, async () => {
                this.setState({ isProcessing: false })
            })
        });
    }
    handleclickCitation = (pageNumber) => {
        let { isChangePage } = this.state;
        this.setState({ PageNumber: pageNumber, isChangePage: !isChangePage })
    }

    render() {
        let { isProcessing, selectedPageNumber, previewURL, isChangePage } = this.state;
        return (<div className="gen-ai-document-window-preview-wrapper">
            {(isProcessing)? <div style={{ textAlign: "center", marginBottom: "10px" }}>
                <img src={imsLoader} alt="Loading Filters" style={{ width: "10%", marginTop: "200px" }} />
            </div> : <>
                {(this.state.fileType.includes('image')) ? <div className="gen-ai-image-container-1">
                    <div className="gen-ai-image-container-2">
                                <img src={`${previewURL}`} className="gen-ai-authoring-img" alt="Notebook preview" />
                    </div></div> :<>
                    {previewURL ? <div className="gen-ai-document-window-preview-panel">
                    <object key={`"gen-ai-document-window-preview-panel-${[selectedPageNumber[0]]}-${isChangePage}`} data={`${previewURL}#page=${selectedPageNumber[0]}`} className={this.context.isCollapsedWindowPreviewInfo ? "gen-ai-document-window-preview-collapsed" : "gen-ai-document-window-preview-expand"} height="100%">
                        <p>Unable to display PDF file.</p>
                    </object>
                </div> : <div className="gen-ai-document-preview-error-panel">
                    <p>Unable to display PDF file.</p>
                </div>}</>
                   }
            </>
            }

        </div>)
    }
}
export default withRouter(NoteBookPreview);
